import { Obj } from '../../../CodesForFoundation';
import { UserLiteData } from '../../../api/ApiTypes';

export const WaitingRoomEntry = (user: UserLiteData, state: 'waiting' | 'keeping') => (
    { ...Obj.pick(user, 'id', 'name', 'email', 'photo', 'color'), state }
);

export type WaitingRoomEntry = ReturnType<typeof WaitingRoomEntry>;
